// extracted by mini-css-extract-plugin
export default {"banner":"qf3PXx"};